<template>
  
  <transition name="fade">
  <div
    class="pageLoading pageFlexCenter"
    v-if="$store.state.pageLoading"
    :style="{backgroundColor: bgColor}"
  >
    <van-button
      type="default"
      size="large"
      :loading="$store.state.pageLoading"
    />
  </div>
  </transition>
</template>

<script>
export default {
  props: {
    bgColor: String
  },
  beforeDestroy () {
    this.$store.commit("setPageLoading", true);
  },
  mounted() {
  }
  
};
</script>

<style scoped lang="less">
.pageLoading {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 60px;
  bottom: env(safe-area-inset-bottom);
  left: 0;
  z-index: 9999;
  background: #fff;
  .van-button {
    border: none;
    background: transparent;
    .van-loading__circular {
      color: var(--defaultColor);
    }
  }
}
.fade-leave-active {
  transition: opacity .4s;
}
.fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
